import { supabase } from "@/lib/supabase";

export interface ConfirmPaydunyaResult {
  ok?: boolean;
  credited?: number;
  ignored?: boolean;
  markedFailed?: boolean;
  status?: string | null;
}

/**
 * Force la re-vérification d'une transaction PayDunya côté serveur.
 * Filet de sécurité quand l'IPN ne s'est pas (encore) déclenché — utilisé
 * à la fois sur la page de retour et depuis le wallet (cas où PayDunya ne
 * redirige plus l'utilisateur vers l'app après paiement).
 */
export async function confirmPaydunyaToken(token: string): Promise<ConfirmPaydunyaResult> {
  const { data, error } = await supabase.functions.invoke("paydunya-confirm", {
    body: { token },
  });
  if (error) throw error;
  return data as ConfirmPaydunyaResult;
}
